const closeDropdowns = (activeEl) => {
  const dropdowns = document.querySelectorAll('.dropdown:not(.is-hoverable)');

  dropdowns.forEach((el) => {
    if (el !== activeEl) el.classList.remove('is-active');
  });
};

const handleDropdownClick = (event) => {
  const dropdownEl = event.target.closest('.dropdown');
  dropdownEl.classList.toggle('is-active');
};

window.addEventListener('click', (event) => {
  const closestDropdown = event.target.closest('.dropdown');
  closeDropdowns(closestDropdown);
});

window.handleDropdownClick = handleDropdownClick;
